export const createProjectWizardMessagesEn = {
  'createProjectWizard.breadcrumb.adminProjects': 'Manage projects',
  'createProjectWizard.breadcrumb.createProject': 'Create project',
  'createProjectWizard.title': 'Create project',

  'createProjectWizard.step.basics.title': 'Basics',
  'createProjectWizard.step.conceptGroupsAndAttributes.title': 'Concept groups',
  'createProjectWizard.step.datasetImport.title': 'Dataset import',
  'createProjectWizard.step.splittingAndDriftCheck.title': 'Data splitting',
  'createProjectWizard.step.allocation.title': 'People & allocation',
  'createProjectWizard.step.reviewAndCreate.title': 'Review & create',

  'createProjectWizard.footer.cancel': 'Cancel',
  'createProjectWizard.footer.saveDraft': 'Save Draft',
  'createProjectWizard.footer.next': 'Next: ',
  'createProjectWizard.footer.back': 'Back',
  'createProjectWizard.footer.createProject': 'Create annotation project',
  'createProjectWizard.footer.createProject.loading': 'Creating annotation project...',

  'createProjectWizard.step.basics.projectName': 'Project name',
  'createProjectWizard.step.basics.projectNamePlaceholder': 'Eg: Asthma IDN1 Jan/2026',
  'createProjectWizard.step.basics.projectNameDescription':
    'Typically use: Condition area + Research partner + month/year',
  'createProjectWizard.step.basics.duplicate.combination':
    'A project with this name, condition area, and research partner combination already exists.',
  'createProjectWizard.step.basics.duplicate.name': 'A project with this name already exists.',
  'createProjectWizard.step.basics.conditionArea': 'Condition area',
  'createProjectWizard.step.basics.conditionAreaPlaceholder': 'Select a condition area',
  'createProjectWizard.step.basics.healthSystemName': 'Research partner',
  'createProjectWizard.step.basics.healthSystemNamePlaceholder': 'Select a research partner',

  'createProjectWizard.step.conceptGroupsAndAttributes.selectConceptGroup.placeholder':
    'Select concept group',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectConceptGroup.title':
    'Similar concept group',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectConceptGroup.description':
    'Search includes full library of concept groups.',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectRequiredAttributes.title':
    'Required attributes',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectRequiredAttributes.description':
    'Select at least 1 required attribute',
  'createProjectWizard.step.conceptGroupsAndAttributes.editcard.doneButton': 'Done',
  'createProjectWizard.step.conceptGroupsAndAttributes.editcard.removeButton': 'Remove',
  'createProjectWizard.step.conceptGroupsAndAttributes.addConceptButton': 'Add concept group',
  'createProjectWizard.step.conceptGroupsAndAttributes.addedConceptCount.chip.label':
    'Concept groups added: {count}',
  'createProjectWizard.step.conceptGroupsAndAttributes.mandatoryAttribute.chip.tooltip':
    '{attributeName} is a mandatory attribute and cannot be de-selected',
  'createProjectWizard.step.datasetImport.s3.upload.button.label': 'Save',
  'createProjectWizard.step.datasetImport.importMode.file-upload': 'File upload',
  'createProjectWizard.step.datasetImport.importMode.s3-path': 'S3 path',
  'createProjectWizard.step.datasetImport.notes.header.title': 'Upload notes file',
  'createProjectWizard.step.datasetImport.person.header.title': 'Upload person file',
  'createProjectWizard.step.datasetImport.visit.header.title': 'Upload visits file',
  'createProjectWizard.step.datasetImport.notes.s3.header.title': 'Notes',
  'createProjectWizard.step.datasetImport.notes.s3.placeholder': 'Enter notes s3 file path',
  'createProjectWizard.step.datasetImport.person.s3.header.title': 'Person',
  'createProjectWizard.step.datasetImport.person.s3.placeholder': 'Enter person s3 file path',
  'createProjectWizard.step.datasetImport.visit.s3.header.title': 'Visit',
  'createProjectWizard.step.datasetImport.visit.s3.placeholder': 'Enter visit s3 file path',
  'createProjectWizard.step.datasetImport.description':
    'Click to upload or drag and drop a parquet file',
  'createProjectWizard.step.splittingAndDriftCheck.header': 'Data splitting file',
  'createProjectWizard.step.splittingAndDriftCheck.s3.header': 'Data splitting file s3 path',
  'createProjectWizard.step.splittingAndDriftCheck.s3.placeholder':
    'Enter data splitting s3 file path',
  'createProjectWizard.step.splittingAndDriftCheck.description':
    'Click to upload or drag and drop a JSON file',
  'createProjectWizard.step.allocation.selectAnnotators.placeholder':
    'Search and select annotators',
  'createProjectWizard.step.allocation.selectSupervisors.placeholder':
    'Search and select supervisors',
  'createProjectWizard.step.allocation.selectAnnotators.title': 'Annotators',
  'createProjectWizard.step.allocation.selectSupervisors.title': 'Supervisors',
  'createProjectWizard.autocomplete.selected': 'Selected',
  'createProjectWizard.step.allocation.allocationMode.title': 'Allocation mode',
  'createProjectWizard.step.allocation.allocationMode.defaultAllocation': 'Default allocation',
  'createProjectWizard.step.allocation.allocationMode.customAllocation': 'Custom allocation',
  'createProjectWizard.step.allocation.allocationConfiguration.trainingAllocation':
    'Training ({count} encounters)',
  'createProjectWizard.step.allocation.allocationConfiguration.testAllocation':
    'Test ({count} encounter)',
  'createProjectWizard.step.allocation.allocationConfiguration.validationAllocation':
    'Validation ({count} encounter)',
  'createProjectWizard.step.allocation.allocationConfiguration.totalMustBe100Percent':
    'Percentages must add up to 100%',
  'createProjectWizard.step.allocation.allocationConfiguration.defaultAllocationMode.description':
    'Default allocation: Encounters will be evenly allocated across annotators. All encounters are double-annotated.',
  'createProjectWizard.step.allocation.allocationConfiguration.selectAnnotator':
    'Please select at least one annotator',

  'createProjectWizard.step.conceptGroupsAndAttributes.header.title': 'Similar concept groups',
  'createProjectWizard.step.conceptGroupsAndAttributes.header.description':
    'Add similar concept groups for this project. For each concept group, select required attributes.',
  'createProjectWizard.step.reviewAndCreate.projectBasics.card.projectName': 'Project name',
  'createProjectWizard.step.reviewAndCreate.projectBasics.card.conditionArea': 'Condition area',
  'createProjectWizard.step.reviewAndCreate.projectBasics.card.healthSystem': 'Health system',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.totalEncounters': 'Total encounters',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.validationEncounters':
    'Validation encounters',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.trainingEncounters':
    'Training encounters',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.testEncounters': 'Test encounters',
  'createProjectWizard.step.reviewAndCreate.conceptAndAttributes.title':
    'Concept groups & required attributes',
  'createProjectWizard.step.reviewAndCreate.conceptAndAttributes.conceptCountSuffix':
    'concept groups',
  'createProjectWizard.step.reviewAndCreate.allocationSummary.title': 'Allocation summary',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.title': 'Dataset summary',

  // Create project success modal
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.title': 'Create project',
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.alert.title': 'Success',
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.alert.description':
    '"{projName}" was created successfully.',
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.close.message':
    'This window will close automatically in {seconds} seconds',
};
